import React, { useContext } from 'react';
import { LinkMenuItem } from '@atlaskit/navigation-system';
import { AnalyticContext } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-starred/src/common/controllers/analytics-context/index.tsx';
import type { JiraStarredOLFItem } from '../../types.tsx';
import { StarJiraItemButton } from './star-jira-item-button/StarJiraItemButton.tsx';

export function StarredMenuLinkItemAdaptor(params: JiraStarredOLFItem): React.JSX.Element {
	const {
		analytics,
		defaultIsStarred = true,
		elemBefore,
		href,
		id,
		onClick,
		primaryLabel,
		typename,
	} = params;

	const { fireUIAnalyticForStarredItems } = useContext(AnalyticContext);

	return (
		<LinkMenuItem
			elemBefore={elemBefore}
			actions={
				<StarJiraItemButton
					analytics={analytics}
					defaultIsStarred={defaultIsStarred}
					id={id}
					name={primaryLabel}
					typename={typename}
				/>
			}
			href={href || ''}
			onClick={(event) => {
				fireUIAnalyticForStarredItems(analytics);
				// It's important to call onClick so that the flyout closes when the menu item is clicked
				onClick?.(event);
			}}
		>
			{primaryLabel}
		</LinkMenuItem>
	);
}
